import React from "react";
import "./point-indicator.css";
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux';
import { unsetImageTagClicked } from "../../actions/CommentAction";
class PointIndicator extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
      }
    }

    render(){
        const {
            pointX = 0,
            pointY = 0,
            imagePoint = 0,
            imageTagClicked
        } = this.props;
        
        // console.log("pointX", pointX, "pointY", pointY, "imagePoint", imagePoint)

        const selectedPoint = imageTagClicked && imageTagClicked.pointX === pointX && imageTagClicked.pointY === pointY && imageTagClicked.index === imagePoint;
        let timeout = null
        if (selectedPoint) {
          clearInterval(timeout)
          timeout = setTimeout(() => {
            this.props.unsetImageTagClicked()
          }, 3000);
        }
        return (
            <div className={"point-ind" + (selectedPoint ? ' point-background' : '')} 
              style = {{
                top: pointY,
                left: pointX,
              }}>
                {imagePoint}
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
  imageTagClicked: state.comments.imageTagClicked
})

const mapDispatchToProps = {
  unsetImageTagClicked
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(PointIndicator))
